import DayJS from 'dayjs';

import { Event } from 'models';

const EventHelpers = {
    urls: {
        upcoming: () => '/events',
        past: () => '/events/past',
        view: (slug: string) => `/events/${slug}`,
        plan: () => '/events/plan',
        claimYourProfile: (eventSlug?: string) =>
            eventSlug ? `/resourcepro/claim-your-profile?event=${eventSlug}` : '/resourcepro/claim-your-profile',
    },

    isCurrentOrUpcoming: (event: Event) => event.isActive || !DayJS(event.end).isBefore(DayJS(), 'day'),

    isHappeningNow: (event: Event) =>
        !DayJS(event.start).isAfter(DayJS(), 'day') && !DayJS(event.end).isBefore(DayJS(), 'day'),

    isUpcoming: (event: Event) => DayJS(event.start).isAfter(DayJS(), 'day'),

    isCurrentUpcomingOrRecent: (event: Event) =>
        event.isActive || !DayJS(event.end).isBefore(DayJS().subtract(2, 'week'), 'day'),

    sortByStart: (events: Event[]) =>
        [...events].sort((first, second) => DayJS(first.start).valueOf() - DayJS(second.start).valueOf()),

    group: (events: Event[], sorting: 'asc' | 'desc') => {
        const groups: {
            [key: string]: {
                timestamp: number;
                name: string;
                events: Event[];
            };
        } = {};

        events.forEach((event) => {
            const startOfPeriod = DayJS(event.start).startOf('month');
            const startOfPeriodTimestamp = startOfPeriod.valueOf();

            groups[startOfPeriodTimestamp] = groups[startOfPeriodTimestamp] || {
                timestamp: startOfPeriodTimestamp,
                name: startOfPeriod.format('MMMM YYYY'),
                events: [],
            };

            groups[startOfPeriodTimestamp].events.push(event);
        });

        return Object.values(groups).sort((a, b) => {
            return sorting === 'asc' ? a.timestamp - b.timestamp : b.timestamp - a.timestamp;
        });
    },

    formatDate: (event: Event) => {
        const startDay = DayJS(event.start).date();
        const startMonth = DayJS(event.start).format('MMM');

        const endDay = DayJS(event.end).date();
        const endMonth = DayJS(event.end).format('MMM');

        if (startDay === endDay) {
            return `${startDay} ${startMonth}`;
        }

        if (startMonth === endMonth) {
            return `${startDay}-${endDay} ${startMonth}`;
        }

        return `${startDay} ${startMonth} - ${endDay} ${endMonth}`;
    },
};

export { EventHelpers };
